import React from 'react';
import { Card, Group, Text, Stack, Box } from '@mantine/core';
import { MessageSquare, Clock } from 'lucide-react';
import { StatusBadge } from './StatusBadge';
import type { SupportTicket } from '../types';
interface TicketCardProps {
  ticket: SupportTicket;
  onClick?: () => void;
}
export function TicketCard({
  ticket,
  onClick
}: TicketCardProps) {
  const formatDate = (dateStr: string) => {
    const date = new Date(dateStr);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffHours / 24);
    if (diffHours < 1) return 'Just now';
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric'
    });
  };
  return <Card shadow="sm" padding="md" radius="md" withBorder onClick={onClick} style={{
    cursor: onClick ? 'pointer' : 'default'
  }} styles={{
    root: {
      borderColor: '#e2e8f0',
      transition: 'all 0.2s ease',
      '&:hover': onClick ? {
        borderColor: '#cbd5e1',
        backgroundColor: '#fafafa',
        transform: 'translateY(-1px)',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)'
      } : {}
    }
  }} data-id="element-115">
      <Stack gap="sm" data-id="element-116">
        <Group justify="space-between" align="flex-start" data-id="element-117">
          <Group gap="sm" wrap="nowrap" style={{
          flex: 1
        }} data-id="element-118">
            <Box p={8} style={{
            backgroundColor: '#f1f5f9',
            borderRadius: 8,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }} data-id="element-119">
              <MessageSquare size={18} color="#1a2332" data-id="element-120" />
            </Box>
            <Stack gap={2} style={{
            flex: 1,
            minWidth: 0
          }} data-id="element-121">
              <Text fw={600} size="sm" c="#1a2332" lineClamp={1} data-id="element-122">
                {ticket.subject}
              </Text>
              <Text size="xs" c="#64748b" tt="uppercase" fw={500} data-id="element-123">
                {ticket.category}
              </Text>
            </Stack>
          </Group>
          <StatusBadge status={ticket.status} data-id="element-124" />
        </Group>

        <Text size="sm" c="#64748b" lineClamp={2} data-id="element-125">
          {ticket.description}
        </Text>

        <Group gap="xs" data-id="element-126">
          <Clock size={12} color="#94a3b8" data-id="element-127" />
          <Text size="xs" c="#94a3b8" data-id="element-128">
            Updated {formatDate(ticket.updatedAt)}
          </Text>
        </Group>
      </Stack>
    </Card>;
}